'use client';

import { useState, useEffect, createContext } from 'react';

import { client } from '@/app/utils/client';
import Contentlet from '@/components/shared/contentlet';
import { DEFAULT_LANGUAGE_ID } from '@/app/utils/constants';

import { FooterBlockNodes } from './BlockNodes';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';

/**
 * Handle the active section state in the footer link section
 * The context is needed to have a reference to the active section on the BlockNodes components
 *
 *  @type {*} */
export const ActiveSectionContext = createContext();

/**
 * LinkSection component
 *
 * @description This component is responsible for fetching and rendering the footer links section
 * @return {*}
 */
export const LinkSection = () => {
    const [contentlet, setContentlet] = useState(null);
    const [activeSection, setActiveSection] = useState(null);

    useEffect(() => {
        const getFooterLink = () => {
            client.content
                .getCollection('webPageContent')
                // Todo: Why this is hardcoded?
                .query("+identifier:'90c5a77d996b10a88d3aa2cfdf80955e'")
                .language(DEFAULT_LANGUAGE_ID)
                .then(({ contentlets = [] }) => {
                    setContentlet(contentlets[0]);
                });
        };

        // client.editor.on('changes', () => {
        //     /**
        //      * For now, until we determine if it is cache or not
        //      * It might be related to this: https://github.com/dotCMS/core/blob/250741a0996c2c7926612fb6c7eaeab9bf36b457/core-web/apps/dotcms-ui/src/app/portlets/dot-edit-page/content/services/dot-edit-content-html/dot-edit-content-html.service.ts#L840-L846
        //      */
        //     setTimeout(() => getFooterLink(), 500);
        // });

        getFooterLink();

        return () => {
            // client.editor.off('changes');
        };
    }, []);

    return (
        <ActiveSectionContext.Provider value={{ activeSection, setActiveSection }}>
            {contentlet?.body && (
                <Contentlet contentlet={contentlet}>
                    <DotBlockEditor
                        className="md:footer-links-container relative flex w-full flex-col"
                        blocks={contentlet.body}
                        customRenderers={FooterBlockNodes}
                    />
                </Contentlet>
            )}
        </ActiveSectionContext.Provider>
    );
};
